import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, inject } from '@angular/core';
import { LDWDocument } from '../../shared/models/LDWDocument';
import { SettingsService } from '../../shared/settings/settings.service';

import { DocumentHistory } from '../../shared/models/document-history';

import { DocumentService } from '../../shared/services/document.service';
import { PdfWebViewer } from '@pdf-tools/four-heights-pdf-web-viewer';
import { UserInformationService } from '../../shell/user-information.service';
import { ViewOptions } from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-api/types';
import { AppConfig } from '../../appconfig';


@Component({
    selector: 'ldw-pdft-history-viewer',
    templateUrl: './pdft-history-viewer.component.html',
    styleUrls: ['./pdft-history-viewer.component.css'],
    standalone: false
})
export class PdftHistoryViewerComponent implements AfterViewInit,OnDestroy{
  private settings = inject(SettingsService);
  private documentService = inject(DocumentService);
  protected userInformationService = inject(UserInformationService);
  private config = inject(AppConfig);

  private _document: LDWDocument | undefined = undefined;
  private _history: DocumentHistory | undefined = undefined;
  @Input() printAllowed = false;
  @Input() downloadAllowed = false;
  blob: Blob = new Blob();

  wvInstance?: PdfWebViewer;
  @ViewChild('viewer') viewer!: ElementRef;
  private viewerLoaded = false;

  private oldid = '';
  private oldFileName = '';

  constructor() {
    this.handlePdfViewerLoaded = this.handlePdfViewerLoaded.bind(this);
  }

  @Input()
  get document(): LDWDocument | undefined {
    return this._document;
  }

  set document(value: LDWDocument | undefined) {
    if (this._document == value) {
      return;
    }
    this._document = value;
    this.openDocument();
  }

  @Input()
  get history(): DocumentHistory | undefined {
    return this._history;
  }

  set history(value: DocumentHistory | undefined) {
    if (this._history == value) {
      return;
    }
    this._history = value;
    this.loadDocumentPdf();
  }

  ngAfterViewInit(): void {
    this.initViewer();
  }

  ngOnDestroy() {
    if (this.wvInstance) {
      // call destroy to release all the allocated resources
      this.wvInstance.destroy();
    }
  }

  private handlePdfViewerLoaded() {
    this.viewerLoaded = true;
    if (this._document) {
      this.openDocument();
    }
  }
  private openDocument() {
    if (this.viewerLoaded) {
      this.loadDocumentPdf();
    }
  }

  get userName(): string {
    const userInfo = this.userInformationService.userInformation;

    if (!userInfo.isEmpty) {
      // return `${userInfo.DisplayName} (${userInfo.LoginName}) - ${userInfo.Department}`;
      return `${userInfo.DisplayName}`;
    }
    return '-';
  }

  initViewer(): void {
    // options can only be set in the constructor.
    // If you need to change some settings, you must create a new PdfWebViewer
    const options = {
      viewer: {
        general: {
          user: this.userName,
          language: this.settings.settings.languages.getSelectedlanguageISO(),
          viewOnly: true,
        },
        permissions: {
          allowFileDrop: false,
          allowOpenFile: false,
          allowPrint: this.printAllowed,
          allowSaveFile: false,  // this.downloadAllowed
        },
      },
    };

    this.wvInstance = new PdfWebViewer(
      this.viewer.nativeElement,
      this.config.editorLicence(),
      options
    );


    if (this.settings.settings.themes.getSelectedTheme() == 0) {
      document.body.setAttribute('data-theme', 'dark');
    } else {
      document.body.setAttribute('data-theme', 'light');
    }

    this.wvInstance.addEventListener('appLoaded', this.handlePdfViewerLoaded);

  }


  loadDocumentPdf() {
    if (this._document == undefined || this._document.id == undefined || this._history == undefined) {
      return;
    }
    if (this._document.id == this.oldid && this._history.fileName == this.oldFileName) {
      return;
    }
    this.oldid = this._document.id;
    this.oldFileName = this._history.fileName;

    this.documentService.getHistoryPdf(this.oldid, this.oldFileName).subscribe(
      res => {
        this.blob = res;

        //      const viewOptions: ViewOptions = { initialPageNumber: this.pageNumber, initialZoom: this.pageZoom };
        const viewOptions: ViewOptions = { initialPageNumber: 1};
        this.wvInstance?.open( {data: this.blob} ,  null, null,  viewOptions)
      }
    );
  }
}
